import { siteInfo, partnerPlaceholder } from '@/mocks/homeData';

export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-base text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              聚合黑料网爆料、爆料黑料网、911爆料网吃瓜黑料等热门黑料，提供最新吃瓜黑料曝光汇总，每日黑料合集与独家内幕，满足吃瓜群众一站式黑料获取需求。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-telegram-line text-background-300 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '最新快讯', href: '#updates' },
                { label: '专题合集', href: '#index' },
                { label: '热度榜单', href: '#ranking' },
                { label: '最新爆料', href: '#cards' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleScroll(link.href); }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {['网红黑料', '娱乐圈八卦', '吃瓜黑料', '独家内幕', '黑料合集'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#cards"
                    onClick={(e) => { e.preventDefault(); handleScroll('#cards'); }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              合作伙伴
            </h4>
            <div className="flex flex-wrap gap-2">
              {partnerPlaceholder.map((p) => (
                <span
                  key={p.name}
                  className="px-3 py-2 bg-background-800 rounded-lg text-xs text-background-400 whitespace-nowrap"
                >
                  {p.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有。本站内容均来自网络公开信息整理，仅供吃瓜交流。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleScroll('#contact'); }} className="hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}